export const TestIds = {
  tagsList: 'tags-list',
};
